(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function() {
    var wrapper = document.querySelector('.header-wrapper--transparente');
    var html = document.documentElement;
    var body = document.body;
    var drawerObserver = null;

    function getMenuDetails() {
      return document.querySelector('header-drawer details');
    }

    function isMobileOrTablet() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    function getHeaderHeight() {
      var headerWrapper = document.querySelector('.section-header .header-wrapper') || document.querySelector('.header-wrapper');
      if (!headerWrapper) return 80;
      return Math.ceil(headerWrapper.getBoundingClientRect().height || headerWrapper.offsetHeight || 80);
    }

    function setSolidHeaderState(isOpen) {
      if (!wrapper) return;

      if (isOpen) {
        wrapper.classList.add('header-wrapper--hover-activo');
        wrapper.classList.add('ai-mobile-drawer-solid');
      } else {
        wrapper.classList.remove('ai-mobile-drawer-solid');

        if (window.scrollY <= 0) {
          wrapper.classList.remove('header-wrapper--hover-activo');
        }
      }
    }

    function syncMenuDrawerState() {
      var details = getMenuDetails();
      var isOpen = !!(details && details.hasAttribute('open') && isMobileOrTablet());

      html.style.setProperty('--ai-mobile-menu-header-height', getHeaderHeight() + 'px');

      if (isOpen) {
        html.classList.add('ai-mobile-menu-open');
        body.classList.add('ai-mobile-menu-open');
        setSolidHeaderState(true);
      } else {
        html.classList.remove('ai-mobile-menu-open');
        body.classList.remove('ai-mobile-menu-open');
        html.style.removeProperty('--ai-mobile-menu-header-height');
        setSolidHeaderState(false);
      }
    }

    function observeDrawer() {
      var details = getMenuDetails();
      if (!details || drawerObserver) return;

      drawerObserver = new MutationObserver(function() {
        requestAnimationFrame(syncMenuDrawerState);
      });

      drawerObserver.observe(details, {
        attributes: true,
        attributeFilter: ['open']
      });
    }

    if (wrapper) {
      wrapper.addEventListener('mouseenter', function() {
        wrapper.classList.add('header-wrapper--hover-activo');
      });

      wrapper.addEventListener('mouseleave', function() {
        var details = getMenuDetails();
        var menuOpen = !!(details && details.hasAttribute('open') && isMobileOrTablet());

        if (!menuOpen && window.scrollY <= 0) {
          wrapper.classList.remove('header-wrapper--hover-activo');
        }
      });

      window.addEventListener('scroll', function() {
        var details = getMenuDetails();
        var menuOpen = !!(details && details.hasAttribute('open') && isMobileOrTablet());

        if (window.scrollY > 50) {
          wrapper.classList.add('header-wrapper--scrolled');
          wrapper.classList.remove('header-wrapper--hover-activo');
        } else {
          wrapper.classList.remove('header-wrapper--scrolled');

          if (menuOpen) {
            wrapper.classList.add('header-wrapper--hover-activo');
          }
        }
      });
    }

    document.addEventListener('toggle', function(event) {
      if (event.target && event.target.matches && event.target.matches('header-drawer details')) {
        requestAnimationFrame(syncMenuDrawerState);
      }
    }, true);

    window.addEventListener('resize', function() {
      html.style.setProperty('--ai-mobile-menu-header-height', getHeaderHeight() + 'px');
      syncMenuDrawerState();
    });

    window.addEventListener('orientationchange', function() {
      setTimeout(function() {
        html.style.setProperty('--ai-mobile-menu-header-height', getHeaderHeight() + 'px');
        syncMenuDrawerState();
      }, 250);
    });

    document.addEventListener('shopify:section:load', function() {
      drawerObserver = null;
      observeDrawer();
      syncMenuDrawerState();
    });

    observeDrawer();
    syncMenuDrawerState();

    setTimeout(function() {
      observeDrawer();
      syncMenuDrawerState();
    }, 400);
  })();

  (function() {
    function setupPremiumMenuIndicator() {
      var inlineMenu = document.querySelector('.header__inline-menu');
      var header = document.querySelector('.header');

      if (!inlineMenu || !header) return;

      var items = inlineMenu.querySelectorAll('.list-menu--inline > li');
      if (!items.length) return;

      items.forEach(function(item) {
        var textTarget = item.querySelector('.header__menu-item span, summary.list-menu__item span, a.list-menu__item--link span, a.list-menu__item--link');
        if (!textTarget) return;

        var itemRect = item.getBoundingClientRect();
        var textRect = textTarget.getBoundingClientRect();
        var headerRect = header.getBoundingClientRect();

        var indicatorLeft = Math.max(0, Math.round(textRect.left - itemRect.left));
        var indicatorWidth = Math.round(textRect.width);
        var indicatorBottomEdge = Math.round(headerRect.bottom - itemRect.top);

        item.style.setProperty('--ai-menu-indicator-left', indicatorLeft + 'px');
        item.style.setProperty('--ai-menu-indicator-width', indicatorWidth + 'px');
        item.style.setProperty('--ai-menu-indicator-bottom-edge', indicatorBottomEdge + 'px');

        var activeLink = item.querySelector('[aria-current="page"], .header__active-menu-item, .list-menu__item--active');
        item.classList.toggle('ai-menu-current', !!activeLink);
      });
    }

    window.addEventListener('load', setupPremiumMenuIndicator);
    window.addEventListener('resize', setupPremiumMenuIndicator);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(setupPremiumMenuIndicator);
    }

    document.addEventListener('shopify:section:load', setupPremiumMenuIndicator);
    document.addEventListener('shopify:section:select', setupPremiumMenuIndicator);

    setTimeout(setupPremiumMenuIndicator, 250);
    setTimeout(setupPremiumMenuIndicator, 1000);
  })();

  (function() {
    var html = document.documentElement;
    var body = document.body;
    var savedScrollY = 0;
    var cartObserver = null;
    var forceCloseButton = null;
    var isClosingCart = false;

    function isMobileOrTablet() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    function getCartElements() {
      return Array.prototype.slice.call(document.querySelectorAll('cart-notification, #cart-notification, .cart-notification-wrapper, cart-drawer, #CartDrawer, .cart-drawer, .drawer--cart'));
    }

    function elementIsVisible(element) {
      if (!element) return false;

      var rect = element.getBoundingClientRect();
      var style = window.getComputedStyle(element);

      return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
    }

    function isCartOpen() {
      var elements = getCartElements();

      for (var i = 0; i < elements.length; i++) {
        var element = elements[i];

        if (
          element.classList.contains('active') ||
          element.classList.contains('is-active') ||
          element.classList.contains('animate') ||
          element.getAttribute('aria-hidden') === 'false' ||
          element.hasAttribute('open')
        ) {
          if (elementIsVisible(element)) return true;
        }
      }

      return false;
    }

    function ensureForceCloseButton() {
      if (forceCloseButton && document.body.contains(forceCloseButton)) return forceCloseButton;

      forceCloseButton = document.createElement('button');
      forceCloseButton.type = 'button';
      forceCloseButton.className = 'ai-cart-force-close-button';
      forceCloseButton.setAttribute('aria-label', 'Close cart');
      forceCloseButton.setAttribute('data-ai-cart-force-close', 'true');

      forceCloseButton.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        closeCart();
      }, true);

      forceCloseButton.addEventListener('touchend', function(event) {
        event.preventDefault();
        event.stopPropagation();
        closeCart();
      }, true);

      document.body.appendChild(forceCloseButton);

      return forceCloseButton;
    }

    function lockCartScroll() {
      if (!isMobileOrTablet()) {
        html.classList.add('ai-cart-drawer-open');
        body.classList.add('ai-cart-drawer-open');
        return;
      }

      if (body.classList.contains('ai-cart-drawer-open')) return;

      savedScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;

      html.classList.add('ai-cart-drawer-open');
      body.classList.add('ai-cart-drawer-open');
      body.style.top = '-' + savedScrollY + 'px';
    }

    function unlockCartScroll() {
      if (!body.classList.contains('ai-cart-drawer-open') && !html.classList.contains('ai-cart-drawer-open')) return;

      html.classList.remove('ai-cart-drawer-open');
      body.classList.remove('ai-cart-drawer-open');

      body.style.position = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      body.style.overflow = '';
      body.style.top = '';

      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden-tablet');
      document.body.classList.remove('overflow-hidden-mobile');

      if (isMobileOrTablet()) {
        window.scrollTo(0, savedScrollY || 0);
      }

      savedScrollY = 0;
    }

    function syncCartState() {
      if (isClosingCart) return;

      ensureForceCloseButton();

      if (isCartOpen()) {
        lockCartScroll();
      } else {
        unlockCartScroll();
      }
    }

    function clickNativeClose() {
      var nativeClose = document.querySelector('cart-notification .cart-notification__close, cart-notification .modal__close-button, cart-drawer .drawer__close, cart-drawer .cart-drawer__close, #CartDrawer .drawer__close, #CartDrawer .cart-drawer__close, .cart-drawer .drawer__close, .drawer--cart .drawer__close');

      if (nativeClose && !nativeClose.hasAttribute('data-ai-cart-force-close')) {
        try {
          nativeClose.click();
        } catch (error) {}
      }
    }

    function closeCart() {
      isClosingCart = true;

      var elements = getCartElements();

      elements.forEach(function(element) {
        if (typeof element.close === 'function') {
          try {
            element.close();
          } catch (error) {}
        }
      });

      clickNativeClose();

      elements.forEach(function(element) {
        element.classList.remove('active', 'is-active', 'animate');
        element.setAttribute('aria-hidden', 'true');
        element.removeAttribute('open');

        element.querySelectorAll('details[open]').forEach(function(details) {
          details.removeAttribute('open');
        });
      });

      unlockCartScroll();

      setTimeout(function() {
        elements = getCartElements();

        elements.forEach(function(element) {
          element.classList.remove('active', 'is-active', 'animate');
          element.setAttribute('aria-hidden', 'true');
          element.removeAttribute('open');
        });

        unlockCartScroll();

        isClosingCart = false;
        syncCartState();
      }, 180);
    }

    function observeCartElements() {
      if (cartObserver) {
        cartObserver.disconnect();
        cartObserver = null;
      }

      var elements = getCartElements();

      if (!elements.length) return;

      cartObserver = new MutationObserver(function() {
        requestAnimationFrame(syncCartState);
      });

      elements.forEach(function(element) {
        cartObserver.observe(element, {
          attributes: true,
          attributeFilter: ['class', 'open', 'aria-hidden', 'style']
        });
      });
    }

    document.addEventListener('click', function(event) {
      var forceButton = event.target.closest('[data-ai-cart-force-close]');

      if (forceButton) {
        event.preventDefault();
        event.stopPropagation();
        closeCart();
        return;
      }

      var nativeClose = event.target.closest('cart-notification .cart-notification__close, cart-notification .modal__close-button, cart-drawer .drawer__close, cart-drawer .cart-drawer__close, #CartDrawer .drawer__close, #CartDrawer .cart-drawer__close, .cart-drawer .drawer__close, .drawer--cart .drawer__close');

      if (nativeClose) {
        event.preventDefault();
        event.stopPropagation();
        closeCart();
        return;
      }

      var cartTrigger = event.target.closest('#cart-icon-bubble, a[href$="/cart"], a[href*="/cart"]');

      if (cartTrigger) {
        ensureForceCloseButton();

        setTimeout(function() {
          observeCartElements();
          syncCartState();
        }, 80);

        setTimeout(function() {
          observeCartElements();
          syncCartState();
        }, 350);

        setTimeout(function() {
          observeCartElements();
          syncCartState();
        }, 800);
      }
    }, true);

    document.addEventListener('keyup', function(event) {
      if (event.key === 'Escape' && isCartOpen()) {
        closeCart();
      }
    });

    window.addEventListener('resize', function() {
      syncCartState();
    });

    window.addEventListener('orientationchange', function() {
      setTimeout(syncCartState, 250);
    });

    document.addEventListener('shopify:section:load', function() {
      ensureForceCloseButton();
      observeCartElements();
      syncCartState();
    });

    ensureForceCloseButton();
    observeCartElements();
    syncCartState();

    setTimeout(function() {
      ensureForceCloseButton();
      observeCartElements();
      syncCartState();
    }, 500);
  })();


  } catch(e) { console.error(e); }
})();
})();
